export const EST = 'Eastern Standard Time';

export const ENG_DATE_FORMAT = 'ddd, MMM Do, YYYY';
